export const HOME_ROUTE = '/';

export const OPERATING_ROOM_HOME = '/operating_rooms';

export function surgeryORConsoleRoute(id: string): string;
export function surgeryORConsoleRoute(id: undefined): undefined;
export function surgeryORConsoleRoute(id: string | undefined): string | undefined;
export function surgeryORConsoleRoute(id: string | undefined): string | undefined {
  return id ? `/operating_rooms/${id}` : undefined;
}
// used to generate the route for the surgery observer for react router
// Added three params to the route. These params are needed to be accessed by the ObserverViewHeader
// Which generates the breadcrumbs.
export const OR_CONSOLE_ROUTE = surgeryORConsoleRoute(':id');

export const MISSION_CONTROL_HOME = '/mission_control';

export const ORGANIZATION_MANAGEMENT_HOME = '/organization_management';
